import React from 'react';

import { Modal, Button } from 'antd';

import { Simple, Intermediate, Full } from 'components/tabs';

export const ReportPreviewModal = ({
  reportType,
  modalReportData,
  setReportType,
  setModalReportData,
}) => {
  return (
    <Modal
      title={
        reportType === 'scf' ? (
          <span>
            Sample Color Fidelity (<i>R</i>
            <sub>
              f,ces<i>i</i>
            </sub>
            )
          </span>
        ) : (
          `${modalReportData.metadata?.identifier}-${
            reportType.charAt(0).toUpperCase() + reportType.slice(1)
          } Report`
        )
      }
      visible={
        modalReportData && Object.keys(modalReportData).length !== 0
          ? true
          : false
      }
      width={['intermediate', 'full'].includes(reportType) ? 1150 : 600}
      onCancel={() => {
        setModalReportData({});
        setReportType('');
      }}
      footer={[
        <Button
          key="close"
          onClick={() => {
            setModalReportData({});
            setReportType('');
          }}
        >
          Close
        </Button>,
      ]}
    >
      {modalReportData &&
        Object.keys(modalReportData).length !== 0 &&
        reportType === 'simple' && <Simple tm30={modalReportData} />}
      {reportType === 'intermediate' && <Intermediate tm30={modalReportData} />}
      {reportType === 'full' && (
        <Full reportData={modalReportData} showMetadataActions={false} />
      )}
      {reportType === 'scf' && (
        <ul className="scf-values">
          {modalReportData['color_sample_fidelity']?.map((value) => (
            <li key={value}>{Math.round(value)}</li>
          ))}
        </ul>
      )}
    </Modal>
  );
};
